// extracted by mini-css-extract-plugin
module.exports = {"announcements":"announcements__MIv6s","announcements__inner":"announcements__inner__cK9HA"};